<template>
  <div>
    <EyeImage class="svg-96 my-0" />
    <p>{{ textDe }}</p>
    <hr />
    <p>{{ textFr }}</p>
    <p>
      <label>
        <input v-model="agreed" name="agreed" type="checkbox" />
        {{ checkboxText }}
      </label>
    </p>
    <ConfirmButton :button-text="buttonText" :disabled="!agreed" />
  </div>
</template>

<script>
import ConfirmButton from "./ModalConfirmButton";
import EyeImage from "./eye.svg";

export default {
  components: {
    ConfirmButton,
    EyeImage,
  },
  props: {
    textDe: {
      type: String,
      required: false,
      default: null,
    },
    textFr: {
      type: String,
      required: false,
      default: null,
    },
    buttonText: {
      type: String,
      required: true,
    },
    checkboxText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      agreed: false,
    };
  },
};
</script>
